import { render, staticRenderFns } from "./ReviewDetailReport.vue?vue&type=template&id=66fc5f59"
import script from "./ReviewDetailReport.vue?vue&type=script&lang=js"
export * from "./ReviewDetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports